import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';

export class BookPropertyConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { attribute, current, incoming } = conflict;

		state.initialCourse.book[attribute] = incoming;
		state.book[attribute] = current;
	};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { attribute, incoming } = conflict;

		state.initialCourse.book[attribute] = incoming;
		state.book[attribute] = incoming;
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { attribute, current, incoming } = conflict;

		state.initialCourse.book[attribute] = incoming;
		state.book[attribute] = `${current} ${incoming}`;
	};
}
